'use client';

import { useRef } from 'react';
import { useOnPageBlur } from '@/components/HtmlHead/hooks/useOnPageBlur';
import { setFaviconHref } from '@/components/HtmlHead/utils';

export interface AnimatedFaviconsProps {
    delay: number;
    hrefs: string[];
}

export function AnimatedFavicons({ delay, hrefs }: AnimatedFaviconsProps) {
    const index = useRef(0);
    const blurCallback = () => {
        index.current = 0;
    };
    const timeoutCallback = () => {
        setFaviconHref(hrefs[index.current]);
        index.current += 1;
        if (index.current >= hrefs.length) {
            index.current = 0;
        }
    };
    useOnPageBlur({
        blurCallback,
        delay,
        timeoutCallback,
    });

    return null;
}
